<template>
  <div class="text-black z-50" v-if="showExpirationPopup">
    <transition name="fade">
      <div
        class="bg-black fixed bg-opacity-80 inset-0 toppest h-screen w-screen"
      >
        <div
          class="fixed center-h-v bg-white sm:w-1/3 w-full px-10 pb-10 shadow-2xl rounded-md"
        >
          <img class="h-14 mx-auto mt-10" src="@/assets/icons/timeup.png" />
          <p class="text-center py-5 text-2xl font-semibold">
            Your session expires in {{ expiresIn }} seconds
          </p>
          <p class="text-center text-sm">
            Do you want to continue your session? Click on keep me logged in.
          </p>
          <div class="w-full flex justify-center mt-8">
            <button
              @click="refreshToken"
              class="text-sm bg-buttonColor hover:bg-primary text-white w-36 p-1.5 rounded-full font-medium"
            >
              Keep my session
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'TokenRefresh',
  data() {
    return {
      expiresIn: 0,
      refreshWarningThreshold: 30,
      timerId: null,
      refreshingToken: false,
      refreshRetries: 0,
      showExpirationPopup: false,
    };
  },
  computed: {
    ...mapGetters([
      'getUser',
      'getOrganization',
      'getToken',
      'getRefreshToken',
      'getAccessTokenExpiresIn',
      'getisAppIdle',
    ]),
  },
  methods: {
    stopTokenTimer() {
      if (this.timerId) clearInterval(this.timerId);
      if (this.refreshIntervalId) clearInterval(this.refreshIntervalId);
    },

    goToLogin() {
      this.$router.replace({
        name: 'login',
        params: { company: this.getOrganization },
      });
    },
    startTokenTimer() {
      this.timerId = setInterval(() => {
        if (this.getUser) {
          const now = new Date();
          const expiresAt = new Date(this.getAccessTokenExpiresIn);
          this.expiresIn = Math.floor((expiresAt - now) / 1000);

          if (this.expiresIn <= 0) {
            if (!this.getisAppIdle && this.expiresIn === 15) {
              this.refreshToken();
            } else {
              this.showExpirationPopup = false;
              this.$store.commit('setIsSessionExpired', true);
              this.goToLogin();
            }
          } else if (
              this.expiresIn <= this.refreshWarningThreshold &&
              !this.getisAppIdle &&
              !this.refreshingToken
          ) {
            this.showExpirationPopup = true;
          } else if (this.expiresIn > this.refreshWarningThreshold) {
            this.showExpirationPopup = false;
          }
        } else {
          this.$store.commit('logout');
        }
      }, 1000);

      // Automatic refresh every 30 minutes
      this.refreshIntervalId = setInterval(() => {
        if (this.getUser && !this.getisAppIdle && !this.refreshingToken) {
          this.refreshToken();
        }
      }, 30 * 60 * 1000);
    },
    refreshToken() {
      this.refreshingToken = true;
      this.refreshRetries += 1;
      const data = {
        AccessToken: this.getToken,
        RefreshToken: this.getRefreshToken,
      };

      axios
        .post(`/oauth/token/${this.$ApiVersion}/refresh`, data, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((response) => {
          if (response.data.StatusCode === 200) {
            this.$store.commit('setToken', response.data.AccessToken);
            this.$store.commit(
              'setAccessTokenExpiresIn',
              response.data.AccessTokenExpires
            );
            this.$store.commit('setRefreshToken', response.data.RefreshToken);

            this.stopTokenTimer();
            this.startTokenTimer();
            this.expiresIn = Math.floor(
              (new Date(this.getAccessTokenExpiresIn) - new Date()) / 1000
            );

            this.showExpirationPopup = false;
          } else {
            if (this.refreshRetries === 3) {
              this.$store.commit('logout');
              this.$notify({
                title: 'Error',
                message: 'Session restoration failed 3 times. Logging out...',
                type: 'error',
              });
            }
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.refreshingToken = false;
          this.$store.commit('setIsAppIdle', false);
        });
    },
  },

  mounted() {
    this.startTokenTimer();
  },
  beforeDestroy() {
    this.stopTokenTimer();
  },
};
</script>
